import React from 'react';
import { useParams } from 'react-router-dom';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { Box } from '@mui/material';
import ClientViewWrapper from '@/components/views/ClientView/ClientViewWrapper';

const ViewClientPage = () => {
	const { clientId } = useParams();

	// Keyed so switching clients (e.g. via global search) remounts the view instead of showing the old client's data.
	return (
		<AuthenticatedPageLayout>
			<Box pb={3}>
				<ClientViewWrapper key={clientId} />
			</Box>
		</AuthenticatedPageLayout>
	);
};

export default ViewClientPage;
